import { Flex, type FlexProps } from "@chakra-ui/react"

export const PageContent = ({ children, ...flexProps }: FlexProps) => {
  return (
    <Flex padding="8" gap="8" position="relative" {...flexProps}>
      {children}
    </Flex>
  )
}
